export default __webpack_public_path__ + "static/media/userIcon.7851de1f.svg";